import React from "react";
import "./commonButton.scss";

const CommonButton = ({ children, ...otherOptions }) => (
  <button className="common_button" {...otherOptions}>{children}</button>
);

export default CommonButton;



// WEBPACK FOOTER //
// ./src/components/common/commonButton.jsx